import { render, staticRenderFns } from "./nutritionMealDialog.vue?vue&type=template&id=c04297a6&scoped=true"
import script from "./nutritionMealDialog.vue?vue&type=script&lang=js"
export * from "./nutritionMealDialog.vue?vue&type=script&lang=js"
import style0 from "./nutritionMealDialog.vue?vue&type=style&index=0&id=c04297a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04297a6",
  null
  
)

export default component.exports